import { useEffect } from "react";

const useCheckClickOutside = (ref, callback) => {
  useEffect(() => {
    const clickListener = (e) => {
      if (!ref.current || ref.current.contains(e.target)) {
        return;
      }
      callback();
    };
    document.addEventListener("mousedown", clickListener);
    document.addEventListener("touchstart", clickListener);
    return () => {
      document.removeEventListener("mousedown", clickListener);
      document.removeEventListener("touchstart", clickListener);
    };
  }, [ref, callback]);
};

export default useCheckClickOutside;
